import PropTypes from "prop-types"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"
import { addAIInvoice, deleteAIInvoice, updateAIInvoice } from "store/aiinvoice/action"
import InvoiceFormModal from "./InvoiceFormModal"
import InvoiceList from "./InvoiceList"

const ManageAIInvoice = () => {
  document.title = "Manage AI Invoice | FlexiTracBoard"

  const dispatch = useDispatch()

  const { invoices } = useSelector(state => ({
    invoices: state.aiInvoice.invoices,
  }))

  // Modal state
  const [modal, setModal]                   = useState(false)
  const [isEdit, setIsEdit]                 = useState(false)
  const [selectedInvoice, setSelectedInvoice] = useState(null)

  // Delete confirmation state
  const [deleteModal, setDeleteModal]         = useState(false)
  const [invoiceToDelete, setInvoiceToDelete] = useState(null)

  const toggle = () => {
    if (modal) {
      setModal(false)
      setSelectedInvoice(null)
      setIsEdit(false)
    } else {
      setModal(true)
    }
  }

  const handleAddNew = () => {
    setSelectedInvoice(null)
    setIsEdit(false)
    setModal(true)
  }

  const handleEdit = invoice => {
    setSelectedInvoice(invoice)
    setIsEdit(true)
    setModal(true)
  }

  const handleDeleteClick = invoice => {
    setInvoiceToDelete(invoice)
    setDeleteModal(true)
  }

  const handleDeleteConfirm = () => {
    if (invoiceToDelete) {
      dispatch(deleteAIInvoice(invoiceToDelete.id))
      setInvoiceToDelete(null)
      setDeleteModal(false)
    }
  }

  const handleSave = invoice => {
    if (isEdit) {
      dispatch(updateAIInvoice(invoice))
    } else {
      dispatch(addAIInvoice(invoice))
    }
  }

  return (
    <React.Fragment>
      {/* Delete Confirmation */}
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteConfirm}
        onCloseClick={() => {
          setDeleteModal(false)
          setInvoiceToDelete(null)
        }}
      />

      {/* Add / Edit Modal */}
      <InvoiceFormModal
        isOpen={modal}
        toggle={toggle}
        isEdit={isEdit}
        selectedInvoice={selectedInvoice}
        onSave={handleSave}
      />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Admin" breadcrumbItem="Manage AI Invoice" />

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  {/* Page header */}
                  <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-2">
                    <div>
                      <h4 className="card-title mb-1">AI Assist Bundle — Invoices</h4>
                      <p className="text-muted mb-0 font-size-13">
                        Manage billing records for AI Assist services.
                      </p>
                    </div>
                    <Button color="primary" onClick={handleAddNew}>
                      <i className="mdi mdi-plus me-1" />
                      Add New Invoice
                    </Button>
                  </div>

                  {/* Invoice table */}
                  <InvoiceList
                    invoices={invoices}
                    onEdit={handleEdit}
                    onDelete={handleDeleteClick}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ManageAIInvoice.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default ManageAIInvoice
